import {features} from '@/model-as-code/features'
import type {GlobalConfigContentItem, Tersed} from '@/services/kontent-ai/types'

export const isFeatureEnabled = (
	featureKey: keyof typeof features,
	globalConfig: Tersed<GlobalConfigContentItem>
): boolean => {
	const featureCodename = features[featureKey]?.codename || ''
	const featureEnabled = globalConfig.elements.features.some((feature) =>
		feature.codename.includes(featureCodename)
	)
	return featureEnabled
}
